import styled from 'styled-components';

export const TimestampStyles = styled.div`
  line-height: 1.25rem;
  font-size: 0.875rem;
  color: var(--color-charcoal);
`;